import * as React from 'react';

function detectBrowserLanguage() {
    return navigator.language || (navigator.languages || [])[0];
}

const CultureContext = React.createContext({ culture: 'en-US' });

interface ICultureProviderProps {
    children: React.ReactNode;
    culture?: string;
}

export function CultureProvider(props: ICultureProviderProps) {
    const { culture = detectBrowserLanguage(), children } = props;
    return (
        <CultureContext.Provider value={{ culture }}>
            {children}
        </CultureContext.Provider>
    );
}

export function withCulture<TProps extends { culture?: string }>(Component: React.ComponentType<TProps>) {
    const WithCulture= React.memo((props: Omit<TProps, 'culture'>) => (
        <CultureContext.Consumer>
            {context => {
                const allProps = { ...props, culture: context.culture } as TProps;
                return React.createElement(Component, allProps);
            }}
        </CultureContext.Consumer>
    ));
    WithCulture.displayName='WithCulture';
    return WithCulture;
}


export const useCulture = () => React.useContext(CultureContext).culture;
